<template>
  <Layout>
    <Title
      title="Naturezas"
      :hasNewRegister="true"
      :routeNewRegister="handleNavigationRegister"
    />
    <Table
      :hasActions="false"
      :tableData="tableData"
      :items="summaryNfseNatures"
      :pagination="true"
      :perPage="paginationNfseNatures.perPage"
      :startItem="paginationNfseNatures.startItem"
      :endItem="paginationNfseNatures.endItem"
      :totalItems="paginationNfseNatures.totalItems"
      :page="paginationNfseNatures.currentPage"
      :onClickRow="handleRowClick"
      :onSearch="search"
      @changeItemsPerPage="changeItemsPerPage"
      @changePage="changePage"
    />
  </Layout>
</template>

<script>
import { Layout, Title, Table, TableData } from '@/components';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'NFSeNatures',
  components: {
    Layout,
    Title,
    Table,
  },
  async mounted() {
    await this.resetNfseNatureState();

    try {
      this.setLoading(true);
      await this.setSummaryNfseNatures({
        pagination: this.paginationNfseNatures,
      });
    } finally {
      this.setLoading(false);
    }
  },
  computed: {
    ...mapState('nfseNatures', [
      'summaryNfseNatures',
      'paginationNfseNatures',
      'nfseWarnings',
    ]),
    tableData() {
      const { Data } = TableData;
      const DataTable = new Data({
        panelActions: true,
        panelActionsSearch: true,
        select: true,
        titleMobile: (item) => item.description,
        onSearch: this.search,
      });

      DataTable.addField({
        key: 'code',
        label: 'Código',
        width: 150,
      }).addField({
        key: 'description',
        label: 'Descrição',
      });
      return DataTable;
    },
  },
  methods: {
    ...mapActions('application', ['setLoading']),
    ...mapActions('nfseNatures', [
      'resetNfseNatureState',
      'setSummaryNfseNatures',
    ]),
    handleRowClick(item) {
      this.$router.push({ name: 'NFSeNaturesEdit', params: { id: item.id } });
    },
    async search(value) {
      this.setLoading(true);
      await this.setSummaryNfseNatures({
        search: value,
        pagination: { ...this.paginationNfseNatures, currentPage: 1 },
      });
      this.setLoading(false);
    },
    async handleNavigationRegister() {
      return this.$router.push({ name: 'NFSeNaturesRegister' });
    },
    async changeItemsPerPage(items) {
      const pagination = {
        ...this.paginationNfseNatures,
        perPage: items,
        currentPage: 1,
      };
      this.setLoading(true);
      await this.setSummaryNfseNatures({ pagination });
      this.setLoading(false);
    },
    async changePage(page) {
      const pagination = {
        ...this.paginationNfseNatures,
        currentPage: page,
      };
      this.setLoading(true);
      await this.setSummaryNfseNatures({ pagination });
      this.setLoading(false);
    },
  },
};
</script>
